import React from "react";
import { ModalService } from "../../../services/modal.service";
import Panel from "../../../panel";
import { HStack, VStack } from "../../../composition/stack.layout";
import Buttons from "../../../button";
import {
  DATA_FEATURE_PROPERTIES,
  ForwardJobApplicationSource,
} from "@/modules/forward/pendo-features";

const ConfirmModal: React.FC<{
  title: string;
  body: string;
  onSubmit: Function;
  submitButtonText?: string;
  onCancel: Function;
  submittedJobOnForward?: boolean;
  forwardJobData?: {
    orgId: string;
    jobId: string;
    source: ForwardJobApplicationSource;
  };
}> = (props) => {
  const confirm = () => {
    props.onSubmit();
    ModalService.closeModal();
  };

  const cancel = () => {
    props.onCancel();
    ModalService.closeModal();
  };

  return (
    <Panel className="relative px-8 py-6">
      <VStack className={"space-y-4"}>
        <HStack>
          <span className={"text-3xl font-medium"}>{props.title}</span>
        </HStack>
        <HStack className={"pb-8 text-lg"}>{props.body}</HStack>
        <HStack className={"justify-end space-x-2"}>
          <Buttons.Standard variant={"secondary"} onClick={() => cancel()}>
            <span>Cancel</span>
          </Buttons.Standard>
          <Buttons.Standard
            variant={"primary-magenta"}
            onClick={() => confirm()}
            {...(props.submittedJobOnForward && props.forwardJobData
              ? DATA_FEATURE_PROPERTIES.submitJobApplicationInForward({
                  orgId: props.forwardJobData?.orgId,
                  jobId: props.forwardJobData?.jobId,
                  source: props.forwardJobData?.source,
                })
              : {})}
          >
            <span>{props.submitButtonText ?? "Confirm"}</span>
          </Buttons.Standard>
        </HStack>
      </VStack>
    </Panel>
  );
};

// Newer (flokit) version of the confirmation modal @/flokit/utils/confirmedCallback.tsx
export const openConfirmModal = (
  title,
  body,
  onSubmit,
  onCancel = () => {},
  submitButtonText = null,
) =>
  ModalService.openModal(
    () => {
      return (
        <React.Fragment>
          <ConfirmModal
            title={title}
            body={body}
            onSubmit={onSubmit}
            onCancel={onCancel}
            submitButtonText={submitButtonText ?? "Confirm"}
          />
        </React.Fragment>
      );
    },
    { width: 600 },
  );

export default ConfirmModal;
